export class Config {
  public static prefixUrl: string =
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:3060/api/'
      : 'https://webclientdev.epi.intra/Thingworx/Things/OAMUXPortalDataLoader.Thing/Services/Main';
}
